<template>
  <v-form ref="form" v-bind="this.$attrs">
    <v-row>
      <v-col class="pb-0" cols="12" md="6">
        <v-autocomplete
          no-data-text="Danh sách trống"
          :items="levelList"
          item-text="title"
          item-value="value"
          v-model="level"
          label="Trình độ"
          outlined
          dense
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6">
        <AutocompleteSubjectGroup return-object v-model="subjectGroup" label="Lĩnh vực" dense hide-details outlined />
      </v-col>
      <v-col class="py-0 mt-n4 mb-4" cols="12" md="12">
        <div class="d-flex align-center">
          <div class="mr-6">Cấp dạy</div>
          <CheckboxAcademicLevel
            :defaults="academicLevels"
            :isDefaultCheckAll="false"
            @change="academicLevels = $event"
          />
        </div>
      </v-col>
      <v-col class="py-0" cols="12" md="6">
        <v-text-field v-model="trainingPlace" label="Nơi đào tạo" outlined dense hide-details />
      </v-col>
      <v-col class="py-0" cols="12" md="6">
        <v-text-field
          v-model="majorDate"
          label="Năm vào ngành"
          type="number"
          :rules="[$rules.yearNotRequired]"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'

export default {
  components: {
    AutocompleteSubjectGroup,
    CheckboxAcademicLevel,
  },
  props: { teacher: Object, formState: Boolean },
  data: () => ({
    level: '',
    levelList: [
      {
        title: 'Thạc sĩ',
        value: 'master-level',
      },
      {
        title: 'Đại học',
        value: 'university-level',
      },
      {
        title: 'Cao đẳng',
        value: 'college-level',
      },
    ],
    subjectGroup: null,
    trainingPlace: '',
    majorDate: '',
    academicLevels: [],
  }),
  created() {
    this.initData()
  },

  methods: {
    initData() {
      if (this.teacher) {
        this.level = get(this.teacher, 'metadata.level')
        this.subjectGroup = this.teacher.subjectGroup
        this.trainingPlace = get(this.teacher, 'metadata.trainingPlace')
        this.majorDate = get(this.teacher, 'metadata.majorDate')
        this.academicLevels = get(this.teacher, 'academicLevels')
      }
    },
    getData() {
      return {
        level: this.level,
        subjectGroup: this.subjectGroup,
        trainingPlace: this.trainingPlace,
        majorDate: this.majorDate,
        academicLevels: this.academicLevels,
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
  watch: {
    formState(formState) {
      if (!formState) {
        this.initData()
      }
    },
  },
}
</script>
